import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from "@angular/core";
import { Modal } from "bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

import {
  ViewService,
  ConfigService,
  ItemService,
  ContainerService,
  OpenContainer,
  WasteStreamService,
  WasteStream,
  ContainerTypeService,
  ContainerType,
  AuthService,
  Person,
  capitalize,
  Item,
  UnitService,
  Container,
  ItemContainerMaterialService,
  OwnerChargeInfo,
} from "../../common";

@Component({
  selector: "item-edit",
  templateUrl: "./item-editor.component.html",
  styleUrls: ["./item-editor.component.css"],
  standalone: false,
})
export class ItemEdit implements OnInit, OnDestroy {
  item: Item;
  items: Item[];
  subscriptions: any[];
  errorMsg: string;
  isChecked = false;
  itemNumber: string;
  containerNumber: string;
  physicalStateOptions: string[];
  container: Container;
  containerTypes: ContainerType[];
  itemContainerMaterials: string[];
  wasteStreams: WasteStream[];
  unitsV: string[];
  unitsW: string[];
  user: Person;
  openContainers: OpenContainer[];
  moveModal: Modal | undefined;
  copyModal: Modal | undefined;
  copyQty: number = 1;
  wasteType: string;
  containerFilter: string;
  @ViewChild("aform") aForm: ElementRef;
  formChanged: boolean;
  parentContainer: OpenContainer;

  constructor(
    public viewService: ViewService,
    private itemService: ItemService,
    private authService: AuthService,
    private configService: ConfigService,
    private containerService: ContainerService,
    private containerTypeService: ContainerTypeService,
    private unitService: UnitService,
    private materialService: ItemContainerMaterialService,
    private wasteStreamService: WasteStreamService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];

    viewService.setViewData({ pageTitle: "Item Editor" });

    this.parentContainer = this.router.getCurrentNavigation().extras.state as OpenContainer;

    console.log(this.parentContainer);

    this.configService.get(true).subscribe((appConfig) => {
      this.physicalStateOptions = appConfig.physicalStateOptions;
    });

    this.containerTypeService.getActive().subscribe((containerTypes) => {
      this.containerTypes = containerTypes.data;
    });
    this.materialService.getActive().subscribe((items) => {
      this.itemContainerMaterials = items.data.map((u) => u.material);
    });
    this.unitService.getActive().subscribe((units) => {
      this.unitsW = units.data
        .filter((u) => u.item && u.unitType === "W")
        .map((u) => u.abbreviation);
      this.unitsV = units.data.filter((u) => u.item).map((u) => u.abbreviation); // V and W units for Volume list
    });
  }

  setOwner(user: Person) {
    this.item.owner = user.cai;
    this.item.ownerName = user.displayName;
    this.item.phone = user.phone;
    this.item.orgCode = user.organization;
    this.item.bldgNo = user.office;
    this.itemService.chargeInfo(user.cai).subscribe((info: OwnerChargeInfo) => {
      this.item.chargeCode = info?.chargeCode;
      this.item.labNo = info?.labNumber;
    });
  }

  setEnteredBy(user: Person) {
    this.item.enteredBy = user.cai;
    this.item.enteredByName = user.displayName;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        this.itemNumber = params["itemId"];

        this.wasteStreamService.getActive().subscribe((wasteStreams) => {
          this.wasteStreams = wasteStreams.data;
          if (this.itemNumber) {
            this.itemService.get(this.itemNumber).subscribe((item) => {
              if (!item.canEdit) {
                this.viewService.back();
              } else {
                this.item = item;
                this.wasteType = item.wasteType;
                this.viewService.setViewData({
                  pageTitle: `Modifying ${item.itemNumber}`,
                });
                if (!this.item.containerNumber) {
                  this.openMove(this.wasteType);
                }
              }
            });
          } else {
            this.reset();
            setTimeout(() => {
              this.viewService.setViewData({ pageTitle: `Adding a new Item` });
            });
          }
        });
      })
    );
  }

  reset() {
    this.authService.getCurrenUser().subscribe((user: Person) => {
      setTimeout(() => {
        this.item = new Item();

        this.item.volumeUnits = "GA";
        this.item.weightUnits = "LB";
        this.item.pickupDate = new Date();
        this.setEnteredBy(user);

        if (this.parentContainer) {
          this.item.containerNumber = capitalize(this.parentContainer.containerNumber);
          this.item.streamName = this.parentContainer.streamName;
          this.item.weightUnits = this.parentContainer.weightUnits;
          this.item.wasteType = this.parentContainer.wasteType;
          if (this.item.wasteType !== "Bulk") {
            this.setWasteStream(
              this.wasteStreams.find((ws) => ws.name === this.parentContainer.streamName)
            );
          }
        } else {
          this.openMove();
        }
      });
    });
  }

  save() {
    this.itemService.save(this.item).subscribe(
      (itm) => {
        this.formChanged = false;
        this.errorMsg = "";
        if (this.item.isNew) {
          this.router.navigate([`items/${itm.itemNumber}/edit`]);
        }
      },
      (error) => (this.errorMsg = error)
    );
  }

  copyOpen() {
    setTimeout(() => {
      if (!this.copyModal)
        this.copyModal = new Modal(document.getElementById("copyModal"), {
          keyboard: false,
          backdrop: "static",
        });
      this.copyModal.show();
    });
  }
  copyClose() {
    this.copyModal?.toggle();
  }

  copyApply() {
    if (!this.formChanged || confirm("Do you wish to continue with unsaved changes?")) {
      let copy = { ...this.item } as Item;
      copy.id = 0;
      this.itemService.save(copy, this.copyQty).subscribe(
        (itm) => {
          this.errorMsg = "";
          this.viewService.back();
        },
        (error) => (this.errorMsg = error)
      );
      this.copyModal?.toggle();
    }
  }

  openMove(type?: string) {
    setTimeout(() => {
      if (!this.moveModal)
        this.moveModal = new Modal(document.getElementById("moveModal"), {
          keyboard: false,
          backdrop: "static",
        });
      this.moveModal.show();
    });
    this.selectType(type);
  }

  selectType(type: string, filter?: string, page?: number) {
    this.wasteType = type;
    this.openContainers = null;
    if (type) {
      const search = type + (filter ? ";" + filter : "");
      this.containerService.getOpenContainers({ search, page }).subscribe((containers) => {
        this.openContainers = containers;
      });
    }
  }

  pageMove(page: number) {
    this.selectType(this.wasteType, this.containerFilter, page);
  }

  filterMove(criteria: string, event: Event) {
    if (event) {
      event.preventDefault();
    }
    let currentValue = criteria ? criteria : "";
    let lastValue = this.containerFilter ? this.containerFilter : "";

    if (currentValue === lastValue) return;

    this.containerFilter = currentValue;

    this.selectType(this.wasteType, this.containerFilter);
  }

  selectMove(container: OpenContainer) {
    if (this.item.isNew) {
      this.item.setContainer(container);
      this.setWasteStream(this.wasteStreams.find((ws) => ws.name === container.streamName));
    } else {
      // If the Item already exists, apply the move action
      this.itemService.move(this.item.id, container.containerNumber).subscribe(
        () => {
          this.errorMsg = "";
          this.item.setContainer(container);
          this.setWasteStream(this.wasteStreams.find((ws) => ws.name === container.streamName));
        },
        (error) => (this.errorMsg = error)
      );
    }
    this.moveModal?.toggle();
    this.errorMsg = "";
  }

  closeMove() {
    if (!this.item.containerNumber) {
      this.viewService.back();
    }
    this.moveModal?.toggle();
  }

  setWasteStream(ws: WasteStream) {
    if (this.item.streamName === ws.name) return;

    this.item.streamName = ws.name;
    if (this.item.isLabPack) {
      this.item.labPackRcra = ws.rcra;
      this.item.wasteCode01 = ws.wasteCode01;
      this.item.wasteCode02 = ws.wasteCode02;
      this.item.wasteCode03 = ws.wasteCode03;
      this.item.wasteCode04 = ws.wasteCode04;
      this.item.wasteCode05 = ws.wasteCode05;
      this.item.wasteCode06 = ws.wasteCode06;
      this.item.wasteCode07 = ws.wasteCode07;
      this.item.wasteCode08 = ws.wasteCode08;
      this.item.wasteCode09 = ws.wasteCode09;
      this.item.wasteCode10 = ws.wasteCode10;
    }
  }

  remove(id: number) {
    if (confirm("Confirm you want to remove this Item?")) {
      this.itemService.remove(id).subscribe(
        () => {
          this.viewService.back();
        },
        (error) => (this.errorMsg = error)
      );
    }
  }

  wcChanged(event) {
    if (event.target.value.length > 3) {
      const wcId = parseInt(event.target.name.substring(9, 11)) + 1;
      const wc = "wasteCode" + wcId.toString().padStart(2, "0");
      const ele = this.aForm.nativeElement[wc];
      if (ele) {
        ele.focus();
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
}
